module.exports = __webpack_public_path__ + "img/tdm.ad1f4464.jpg";